import { makeObservable, observable, action, reaction, toJS, when } from 'mobx';
import axios, { storeGet } from "../utils/axios";
import { animateScroll } from 'react-scroll';
import {  stores } from "../history_mobx";
import qs from "qs";

class spyingStore {
  list = {inited: false, fetching: false, data: {}};
  counters = {inited: false, fetching: false, data: {}};

  constructor(par) {
    this.par = par;
    makeObservable(this, {
      list: observable,
      counters: observable,
    });
  }

  loadCounters() {
    storeGet('/sysapi/spying/groups', this.counters)
  }

  loadComments(opts) {
    const get=qs.stringify(opts);
    this.list.fetching=true;
    storeGet(`/sysapi/spying?${get}`, this.list);
  }
}

export default spyingStore;